import axios from 'axios';

export default function fetchHandler({
    url,
    method = 'GET',
    actionType,
    headers,
    body,
    params = null, // for GET requests

    shouldDispatch = true,

    noContentType = false,
    contentType = 'application/json',
    callBack = null,
    showToast = false,
    cancelToken = null,
    isDataTable = false,
    dispatchParams = null,
}) {
    return async (dispatch, getState) => {
        let headersData = {
            Accept: '*/*',
            'Accept-Language': 'en_US',
        };

        if (!noContentType) {
            headersData['Content-Type'] = contentType || 'application/json';
        }

        headersData = {
            ...headersData,
            ...headers,
        };

        let error;

        try {
            const promise = axios({
                url,
                method,
                params,
                headers: {
                    ...headersData,
                },
                data: body,
                // cancelToken: cancelToken,
            }).catch((error) => {
                throw error;
            });
            const response = await promise;
            if (response.status >= 200 && response.status <= 226) {
                return defaultSuccessHandler(
                    response,
                    actionType,
                    dispatch,
                    shouldDispatch,
                    callBack,
                    showToast,
                    isDataTable
                );
            } else {
                error = handleErrors(response, dispatch);
            }
        } catch (e) {
            error = handleErrors(e);
        }
        if (error) {
            return error;
        }
    };
}

function defaultSuccessHandler(
    res,
    actionType,
    dispatch,
    shouldDispatch,
    callBack,
    showToast,
    isDataTable
) {
    let json;
    try {
        json = res.data;
    } catch (error) {
        console.log('Unknown error '); // eslint-disable-line no-console
    }
    json = json || {};

    if (callBack) {
        callBack(json);
    }
    if (shouldDispatch) {
        dispatch({
            type: actionType,
            payload: json,
        });
        return json;
    } else {
        return json;
    }
}

/**
 * Function for handling toast error messages for various API requests if showToast is enabled.
 * @param {*} response
 * @param {*} dispatch
 * @param {*} errorHandler
 * @param {*} showToast
 */
function handleErrors(response, dispatch) {
    let error = null;
    try {
        error = response;
    } catch (e) {
        error = response;
    }

    return error;
}
